import { Component, ElementRef, Input } from '@angular/core';
import { AppLocalizationService } from '@app/shared/common/localization/app-localization.service';

@Component({
    selector: '<validation-label>',
    template: `<label [ngClass]="{'m--font-danger': !formCtrl.valid && (formCtrl.dirty || formCtrl.touched)}">{{inputLabel}}<span *ngIf="requiredInput" style="color: red">*</span></label>`
})
export class ValidationLabelComponent {

    @Input() formCtrl;
    @Input() inputLabel: string;
    @Input() requiredInput: boolean;

    private _elementRef: ElementRef;
    private _appLocalizationService: AppLocalizationService;

    constructor(
        private elementRef: ElementRef,
        private appLocalizationService: AppLocalizationService
    ) {
        this._elementRef = elementRef;
        this._appLocalizationService = appLocalizationService;
    }

    
}
